import { persistor, sagaMiddleware, store } from '@Bootstraps'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { Provider } from 'react-redux'
import { Route } from '@Layouts'
import bootstrapSaga from '@Bootstraps/bootstrapSagas'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import '@Styles/app.css'

export default function App() {
    sagaMiddleware.run(bootstrapSaga);

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Route />
            </PersistGate>
        </Provider>
    )
}